<template>
  <div class="container-fluid">
    <div class="header">
      <h3>Thrive Through Change Growth Mindset Quiz</h3>
    </div>

    <div class="container box">
      <div class="row">
        <div class="col">
          <span class="questionCount text-center question-header">QUESTION {{index}} of 10</span>
        </div>
      </div>
      <div>
        <p class="question question-text">
          <strong>{{ questions[index-1].question }}</strong>
        </p>
      </div>

      <div>
        <MyLottie
          :index="index"
          :valor="myValue"
          v-on:answer="getAnswer"
          v-on:prev="onPrev"
          v-on:next="onNext"
        />
      </div>

      <br>
    </div>
  </div>
</template>


<script>
import MyLottie from "@/components/MyLottie.vue";
export default {
  name: "Question",
  components: {
    MyLottie
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      index: 2, //  variable that tells us what question we are
      myValue: JSON.parse(localStorage.getItem("answers"))[1].answer - 1, // variable that is used to restart the slider
      answers: [], // variable with the answers
      questions: [
        // variable with the questions is used for the iteration
        {
          id: 1,
          animation: 1,
          question: "I try to outperform my coworkers."
        },
        {
          id: 2,
          animation: 2,
          question:
            "I like having colleagues who can teach me something about myself, even if it isn’t always positive."
        },
        {
          id: 3,
          animation: 3,
          question:
            "I’m always seeking opportunities to develop new skills and acquire new knowledge."
        },
        {
          id: 4,
          animation: 4,
          question:
            "I really care about making a good impression on other people."
        },
        {
          id: 5,
          animation: 5,
          question: "It’s important to me to show that I am smart and capable."
        },
        {
          id: 6,
          animation: 6,
          question:
            "I strive to have open and honest relationships with my coworkers."
        },
        {
          id: 7,
          animation: 7,
          question: "I work to constantly learn and improve at my job."
        },
        {
          id: 8,
          animation: 8,
          question:
            "When I’m with my coworkers, I think a lot about how I’m “coming across” to them."
        },
        {
          id: 9,
          animation: 9,
          question:
            "I feel good about myself when I know that my colleagues like or are impressed by me."
        },
        {
          id: 10,
          animation: 10,
          question:
            "I like to work with, and for, people who challenge me to change for the better."
        }
      ]
    };
  },
  mounted() {
    console.log("App mounted!");
    // we get the answers from localstorage
    if (localStorage.getItem("answers"))
      this.answers = JSON.parse(localStorage.getItem("answers"));
  },
  watch: {
    // we check if there are changes in the answers and we keep them locally
    answers: {
      handler() {
        console.log("Answer changed!");
        localStorage.setItem("answers", JSON.stringify(this.answers));
      },
      deep: true
    }
  },
  methods: {
    /**
     *
     *  it is used to change the question to the next
     */

    onNext(next) {
      console.log("next");
      this.index++; // we increase the index
      if (this.index === 11) {
        // if it is the last question, show the results layer
        this.$router.push({ name: "result" });
      } else {
        // show the next question
        this.$router.push({ name: "question", params: { num: this.index } });
      }
    },

    /**
     *
     *  go back to previous question
     */

    onPrev(prev) {
      this.index--;
      if (this.index === 1) {
        // if its the last question show the results layer
        this.$router.push({ name: "start" });
      } else {
        this.$router.push({ name: "question", params: { num: this.index } });
      }
    },

    /**
     * 
        This method is used to obtain the response of the range slider
     */
    getAnswer(answer) {
      // you have to parse to number to avoid errors
      this.answers[this.index - 1].answer = parseInt(answer, 10) + 1;
      console.log("answer", answer);
    }
  }
}; /*eslint-disablr */
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  padding-top: 20px;
}

.header {
  background: #0070bc;
  font-style: italic;
  color: white;
  min-height: 43px;
  padding: 10px 0;
}
p {
  padding-top: 15px;
  font-size: 18px;
}
.header h3 {
  font-weight: 600;
  font-size: 20px;
  padding-top: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
h4 {
  font-size: 16px;
}
ul li {
  list-style-type: none;
  display: inline;
}
.question {
  font-size: 18px;
}
.questionCount {
  font-size: 12px;
}
.question-header {
  font-size: 14px;
  text-transform: uppercase;
  color: #ccc;
  float: right;
}

.question-text {
  font-weight: bold;
  font-size: 18px;
  margin: 10px 0;
}

/*  /*iPhone 6/7/8pluses* /Media Query */
@media only screen and (min-device-width: 411px) and (max-device-width: 736px) and (orientation: portrait) {
  .header {
    height: 42px;
  }
  .header h3 {
    padding-top: 13px;
    font-size: 17px;
  }
}

/* Media Queries */
@media only screen and (max-width: 600px) {
  .spacer.col {
    display: none;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .spacer.col {
    display: none;
  }
}

/* Medium devices (landscape tablets, 768px and up ) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up ) */
@media only screen and (min-width: 992px) {
}

/* Extra Large devices (large laptops/desktops, 1200px and up ) */
@media only screen and (min-width: 1200px) {
}

.hint {
  display: none !important;
}
</style>

